import styled from 'styled-components';

export const BaseIcon = styled.svg`
  @media (min-width: 576px) {
    margin-right: 20px;
  }
`;
